import React from 'react';

interface TableRowsPerPageProps {
  options?: (number | string)[];
  value: number | string;
  onSelect: (value: number) => void;
}

const OPTIONS: (number | string)[] = [5, 10, 15, 20];

const TableRowsPerPage: React.FC<TableRowsPerPageProps> = ({
  options = OPTIONS,
  value,
  onSelect,
}) => {
  return (
    <div className='d-inline-block'>
      <label className='mx-2 float_lt mt-2'>Records Per Page</label>
      <select
        className='form-select form-select-sm float_lt wid-60'
        value={value}
        onChange={(e) => onSelect(Number(e.target.value))}
      >
        {options.map((item) => (
          <option key={item} value={item}>
            {item || ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TableRowsPerPage;
